import {DefaultValue, Header, ResponsePath, ActivePage} from './reducer'
import {createAction} from 'typesafe-actions'
import {ExternalDataFeedObject} from 'airship/clients/xdf/types'

// open / close the form
export const openXDFForm = createAction('@XDF/XDF-FORM/OPEN-XDF-FORM')()
export const openXDFFormToEdit = createAction(
  '@XDF/XDF-FORM/OPEN-XDF-FORM-TO-EDIT'
)<ExternalDataFeedObject>()
export const closeXDFForm = createAction('@XDF/XDF-FORM/CLOSE-XDF-FORM')()

// normal form fields
export const setFriendlyName = createAction(
  '@XDF/XDF-FORM/SET-FRIENDLY-NAME'
)<string>()
export const setFeedID = createAction('@XDF/XDF-FORM/SET-FEED-ID')<string>()
export const setDescription = createAction(
  '@XDF/XDF-FORM/SET-DESCRIPTION'
)<string>()
export const setRequestURL = createAction(
  '@XDF/XDF-FORM/SET-REQUEST-URL'
)<string>()
export const setConfirmedDomain = createAction(
  '@XDF/XDF-FORM/SET-CONFIRMED-DOMAIN'
)<string>()
export const setCacheResponse = createAction(
  '@XDF/XDF-FORM/SET-CACHE-RESPONSE'
)<boolean>()
export const setConfirmedAccessRights = createAction(
  '@XDF/XDF-FORM/SET-CONFIRMED-ACCESS-RIGHTS'
)<boolean>()

// placeholders / default values list
export const setValidPlaceholders = createAction(
  '@XDF/XDF-FORM/SET-VALID-PLACEHOLDERS'
)<string[]>()
export const setDefaultValue = createAction(
  '@XDF/XDF-FORM/SET-DEFAULT-VALUE'
)<DefaultValue>()

// headers list
export const addHeader = createAction('@XDF/XDF-FORM/ADD-HEADER')<
  Omit<Header, 'id'>
>()
export const updateHeader = createAction(
  '@XDF/XDF-FORM/UPDATE-HEADER'
)<Header>()
export const removeHeader = createAction(
  '@XDF/XDF-FORM/REMOVE-HEADER'
)<string>()

// response paths list
export const addResponsePath = createAction('@XDF/XDF-FORM/ADD-RESPONSE-PATH')<
  Omit<ResponsePath, 'id'>
>()
export const updateResponsePath = createAction(
  '@XDF/XDF-FORM/UPDATE-RESPONSE-PATH'
)<ResponsePath>()
export const removeResponsePath = createAction(
  '@XDF/XDF-FORM/REMOVE-RESPONSE-PATH'
)<string>()

// form `meta` info
export const setActivePage = createAction(
  '@XDF/XDF-FORM/SET-ACTIVE-PAGE'
)<ActivePage>()
export const setFormIsValid = createAction(
  '@XDF/XDF-FORM/SET-FORM-IS-VALID'
)<boolean>()
export const setShowValidationErrors = createAction(
  '@XDF/XDF-FORM/SET-SHOW-VALIDATION-ERRORS'
)<boolean>()

export const toggleThrottleRate = createAction(
  '@XDF/XDF-FORM/TOGGLE-THROTTLE-RATE'
)<boolean>()
export const setThrottleRate = createAction(
  '@XDF/XDF-FORM/SET-THROTTLE-RATE'
)<number>()
